<template>
  <div>
    <b-row>
      <b-col>
        <toggle-single id="enable-agenda"
                       label-name="Enabled"
                       :toggle-model="useCompanyInfo"
                       @toggle-click="handleToggleClick"
        />
      </b-col>
      <b-col>
        <b-link
            class="float-right"
          @click="handleResetClick">
        Reset
        </b-link>
      </b-col>
    </b-row>

    <!--LOGO -->
    <div style="text-align: center; margin-bottom: 15px">
      <b-img
          v-if="companyImgURL"
          v-bind="mainProps"
          thumbnail
          fluid
          :src="companyImgURL"
          :alt="`${companyName} logo`"
      />
    </div>
    <!-- NAME -->
    <b-form-group>
      <label-info
          id="session-companyName"
          label-name="Company Name"
          label-info=""
          :is-required="true"
      />
      <b-form-input
          type="text"
          required
          v-model="companyName"
          @input="handleValueChange('company.name', companyName)"
          placeholder="My Session"
      />
    </b-form-group>

    <!-- PHONE -->
    <b-form-group>
      <label-info
          id="session-contactPhone"
          label-name="Contact Phone"
          label-info=""
          :is-required="false"
      />
      <the-mask
          id="phone"
          :mask="[' (###) ###-####', '##.###.###/####-##']"
          class="custom-input"
          style="width:100%"
          type="tel"
          v-model="companyPhone"
          @input="handleValueChange('company.phone', companyPhone)"
          placeholder="(310) 621-4068"
      />
    </b-form-group>

    <!-- EMAIL -->
    <b-form-group>
      <label-info
          id="session-companyEmail"
          label-name="Company Email"
          label-info=""
          :is-required="false"
      />
      <b-form-input
          type="text"
          required
          v-model="companyEmail"
          @input="handleValueChange('company.email', companyEmail)"
          placeholder="@"
      />
    </b-form-group>

    <!--- DESCRIPTION  -->
    <b-form-group>
      <label-info
          id="session-companyBio"
          label-name="Bio"
          label-info=""
          :is-required="true"
      />
      <transition name="fadeHeight" mode="out-in">
        <Editor
            id="textarea-default"
            v-show="true"
            @input="input"
            :clear="clear"
            :content="companyBio"
            @resetClear="resetClear"
        />
      </transition>
    </b-form-group>
    <pre v-if="!production" class="small">{{ context }}</pre>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import LabelInfo from "@/components/common/labelInfo";
import Editor from "@/components/common/editor";
import ToggleSingle from "@/components/common/toggleSingle";
import TheMask from "vue-the-mask/src/component";
export default {
  name: "AddEditCarePlan_CompanyInfo",
  components: {
    LabelInfo,
    Editor,
    ToggleSingle,
    TheMask
  },
  props: {
    form: {
      type: Object,
      default: ()=>{
        return {}
      }
    }
  },
  beforeMount() {},
  mounted() {},
  computed: {
    ...mapGetters({}),
    companyName() {
      return this.form && this.form.company  && this.form.company.name ? this.form.company.name : null;
    },
    companyEmail(){
      return this.form && this.form.company && this.form.company.email ?  this.form.company.email : null;
    },
    companyPhone(){
      return this.form && this.form.company && this.form.company.phone ?  this.form.company.phone : null;
    },
    companyExpertise(){
      return this.form && this.form.company && this.form.company.expertise ? this.form.company.expertise : null;
    },
    companyBio(){
      return this.form && this.form.company && this.form.company.bio ? this.form.company.bio : null;
    },
    companyImgURL(){
      return this.form && this.form.company && this.form.company.imgURL ? this.form.company.imgURL : null;
    }
  },
  methods: {
    handleToggleClick(){
      this.useCompanyInfo = !this.useCompanyInfo;
      this.handleValueChange('useCompanyInfo', this.useCompanyInfo);
    },
    handleResetClick(){
      this.$emit('reset-click');
    },
    handleValueChange(key,value) { //mixin
      this.$emit('value-change', {key:key, value:value});
      this.$forceUpdate();
    },
    input(val) {
      this.$emit('value-change', {key:'companyBio', value:val.content});
    },
    resetClear() {
      this.clear = false;
    },
    validationStatus(validation) {
      return typeof validation != "undefined" ? validation.$error : false;
    },
    handleCalendarDateSelected(date){
      this.$emit('value-change', {key:'session_date_at', value: date});
    },
    handleCalendarFocusClick(isFocused){
      this.calendar = isFocused;
    }
  },
  data() {
    return {
      useCompanyInfo: this.form && this.form.useCompanyInfo ? this.form.useCompanyInfo : false,
      production: true,
      mainProps: {
        blank: false,
        blankColor: '#777',
        width: 150,
        height: 150,
        class: 'm1'
      },
      clear: false,
      calendar: false,
      context: null
    };
  },
};
</script>

<style lang="scss" scoped>
.birthday_input {
  position: relative;
}
.session-calendar-wrapper {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1;
}
#session_calender .btn-outline-info:hover,
#session_calender .btn-outline-info:active,
#session_calender .btn-outline-info:focus {
  background-color: var(--theme-color);
  background: var(--theme-color);
}
</style>

